import React, { useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import ProgressSection from './ProgressSection';
import { ScanDetails } from 'types/scan';

interface ProgressComparisonTabsProps {
  progress: Record<string, any>;
  scans: ScanDetails[];
  selectedScan: string;
  analyticsCreatedAt?: string;
  selectedScanData?: ScanDetails;
}

const ProgressComparisonTabs: React.FC<ProgressComparisonTabsProps> = ({
  progress,
  scans,
  selectedScan,
  analyticsCreatedAt,
  selectedScanData,
}) => {
  const availableComparisonIds = Object.keys(progress);
  const [comparedScanId, setComparedScanId] = useState(availableComparisonIds[0] || '');

  // Only show the selected comparison
  const filteredProgress = comparedScanId ? { [comparedScanId]: progress[comparedScanId] } : {};

  return (
    <Box>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h2" sx={{ mb: 0 }}>Progress Comparison</Typography>
        <FormControl size="small">
          <InputLabel id="compare-scan-select-label">Compare With</InputLabel>
          <Select
            labelId="compare-scan-select-label"
            value={comparedScanId}
            label="Compare With"
            onChange={e => setComparedScanId(e.target.value)}
            sx={{ minWidth: 200 }}
          >
            {availableComparisonIds.map(scanId => {
              const scan = scans.find(s => s.id === scanId);
              return (
                <MenuItem key={scanId} value={scanId}>
                  {scan?.description ? `${scan.description} - ` : ''}
                  {scan?.scanDate ? new Date(scan.scanDate).toLocaleDateString() : scanId}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
      <ProgressSection
        progress={filteredProgress}
        scans={scans}
        selectedScan={selectedScan}
        analyticsCreatedAt={analyticsCreatedAt}
        selectedScanData={selectedScanData}
      />
    </Box>
  );
};

export default ProgressComparisonTabs;
